import { Broadcaster } from './events-v7';

import { AuthGuard } from './auth-guard.service';
import { HttpCemex } from './http.service';
import { ProjectSettings } from './project.settings';
import { SessionService } from './session.service';
import { TranslationService } from './translation.service';
import { CountryConfigService } from './country-config.service';

export const CORE_COMMON_PROVIDERS = [
  ProjectSettings,
  HttpCemex,
  SessionService,
  Broadcaster,
  AuthGuard,
  TranslationService,
  CountryConfigService
];
